import React, { useEffect, useState } from 'react';
import SbEditable from 'storyblok-react';
import { Helmet } from 'react-helmet';
import queryString from 'query-string';
import styled from 'styled-components';

import { leads } from '../../services';

const PartnerName = (props) => {
  const [partnerName, setPartnerName] = useState();

  useEffect(() => {
    async function fetchData() {
      if (typeof window !== undefined) {
        const parsed = queryString.parse(window.location.search);

        if (parsed && parsed.partnerId) {
          const apiName = await leads.getPartnerInfo(parsed.partnerId);
          setPartnerName(apiName);
        } else if (window.location.pathname.startsWith('/editor')) {
          setPartnerName('PARTNER NAME HERE');
        } else {
          setPartnerName('');
        }
      }
    }

    fetchData();
  }, [setPartnerName]);

  const hasPartnerName = !!partnerName;

  return (
    <>
      <Helmet>
        <title>{partnerName || 'Partner'} - Swell Energy</title>
        <meta name="twitter:title" content={`${partnerName || 'Partner'} - Swell Energy`} />
      </Helmet>
      {hasPartnerName && (
        <SbEditable content={props.blok}>
          <PartnerNameText theme={props.blok.theme} fontSize={props.blok.font_size}>
            {(props.blok.format || '%NAME%').replace(/%NAME%/g, partnerName)}
          </PartnerNameText>
        </SbEditable>
      )}
    </>
  );
};

const PartnerNameText = styled.span`
  color: ${(props) => (props.theme === 'light' ? '#000000' : '#ffffff')};
  font-size: ${(props) => (props.fontSize || 1)}rem;
  line-height: 115%;
`;

export default PartnerName;
